/**
 * Gestion de fichier sprite SVG
 * Et implémentation de SVG via classes CSS
 */

// Import des svg dans le lepreuchaun (sprite)
requireAll(require.context('../icon/', true, /\.svg$/));

jQuery(document).ready(function () {
    setSvg();

    jQuery('.slick').on('init', function () {
        setSvg();
    });
});

jQuery(document).ajaxComplete(function () {
    setSvg();
});

jQuery(document).on('frmPageChanged', function (event, form, response) {
    setSvg();
});

// Autoloader JS
function requireAll(r) {
    r.keys().forEach(r);
}

// Ajout de SVG par détection de classes CSS : use-icon use-icon-[NAME]
function setSvg() {
    let use_svg = jQuery('.use-svg:not(.is-loaded)');
    if (use_svg.length) {
        use_svg.each(function () {
            let elt = jQuery(this);
            let classList = jQuery(this).attr('class').split(/\s+/);
            jQuery.each(classList, function (index, item) {
                if (item.includes('use-icon-')) {
                    jQuery(elt).addClass('is-loaded');
                    let svg = item.replace('use-', '');
                    elt.prepend('<svg class="sprite-icon sprite-' + svg + '"><use xlink:href="#' + svg + '"></use></svg>');
                }

                if (item.includes('use-pattern-')) {
                    jQuery(elt).addClass('is-loaded');
                    let svg = item.replace('use-', '');
                    elt.prepend('<svg class="sprite-pattern sprite-' + svg + '"><use xlink:href="#' + svg + '"></use></svg>');

                    if(svg === 'pattern-12') {
                        let paddingTop = elt.css('padding-top');
                        if (paddingTop != null) {
                            paddingTop = parseInt(paddingTop.slice(0, -2)) + 50;
                            jQuery(elt).css('padding-top', paddingTop);
                        }

                        let paddingBottom = elt.css('padding-bottom');
                        if (paddingBottom != null) {
                            paddingBottom = parseInt(paddingBottom.slice(0, -2)) + 50;
                            jQuery(elt).css('padding-bottom', paddingBottom);
                        }

                        let marginTop = elt.css('margin-top');
                        if (paddingBottom != null) {
                            marginTop = parseInt(marginTop.slice(0, -2)) + 50;
                            // jQuery(elt).css('margin-top', marginTop);
                        }
                        
                        let elt_last_1 = jQuery('.site-content > .container:first-child > div:last-child');
                        let elt_last_2 = jQuery('.site-content > .container:first-child > .vc_row:last');

                        let marginTopElt1 = elt_last_1.css('padding-bottom');
                        if (marginTopElt1 != null) {
                            marginTopElt1 = parseInt(marginTopElt1.slice(0, -2)) + 25;
                            jQuery(elt_last_1).css('padding-bottom', marginTopElt1);
                        }

                        let marginTopElt2 = elt_last_2.css('padding-bottom');
                        if (marginTopElt2 != null) {
                            marginTopElt2 = parseInt(marginTopElt2.slice(0, -2)) + 25;
                            jQuery(elt_last_2).css('padding-bottom', marginTopElt2);
                        }
                    }
                }
            });
        });
    }
}
